import { render, staticRenderFns } from "./intermediateStandby.vue?vue&type=template&id=6bd4bd31&scoped=true&"
import script from "./intermediateStandby.vue?vue&type=script&lang=ts&"
export * from "./intermediateStandby.vue?vue&type=script&lang=ts&"
import style0 from "./intermediateStandby.vue?vue&type=style&index=0&id=6bd4bd31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4bd31",
  null
  
)

export default component.exports